'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PushCartErrors = PushCartErrors;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _pushCartActions = require('../../../store/actions/push-cart-actions');

var pushCartActions = _interopRequireWildcard(_pushCartActions);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function PushCartErrors(_ref) {
  var errors = _ref.errors;

  var dispatch = (0, _reactRedux.useDispatch)();

  var handleErrorClose = function handleErrorClose(event, error) {
    var key = error.key;
    var target = event.target;

    dispatch(pushCartActions.toggleError(key));

    target.closest('.psh-Errors_Item').addEventListener('transitionend', function (e) {
      if (e.propertyName === 'visibility') {
        dispatch(pushCartActions.removeError(key));
      }
    });
  };

  return _react2.default.createElement('div', { className: 'psh-Errors' }, errors.map(function (error) {
    return _react2.default.createElement('div', { className: 'psh-Errors_Item', 'aria-hidden': String(!error.show), key: error.key }, error.message, _react2.default.createElement('div', { className: 'psh-Errors_Close', onClick: function onClick(e) {
        return handleErrorClose(e, error);
      } }, _react2.default.createElement('span', { className: 'am-icon-close-thin' })));
  }));
}

PushCartErrors.propTypes = {
  errors: _propTypes2.default.array.isRequired
};